export class AnonymousRetailSalesConstants {
    public static participatingStores = 'ParticipatingStores';
    public static currentRetailStores = 'RetailStores';
    public static Country = 'Country';
    public static Year = 'Year';
    public static Month = 'Month';
    public static CC = 'CC';
    public static Subscribers = 'Subscribers';
    public static OrderCC = 'OrderCC';
    public static OrderTotal = 'OrderTotal';
    public static ApprovedBy = 'ApprovedBy';
    public static ApprovedTimestamp = 'ApprovedTimestamp';
    public static PageSize = 10;
    public static PageNumber = 1;
    public static DESC = 'DESC';
    public static ASC = 'ASC';
    public static YearValue = 2022;
    public static SuccessIcon = "check-circle-o";
    public static CloseIcon = "close";
    public static CREATE = "create";
    public static EDIT = "edit";
    public static AnonymousRetailSales = "Anonymous Retail Sales";
    public static RetailSales = "anonymousRetailSales";
    public static CSP = "CSP";
    public static Account_Service = "account_service";
    public static SomethingWentWrong = "Something went wrong";
    public static Error_Occured_While_Retriving_Stores = "Error occured while retriving stores";
    public static Error_Occured_While_Retail_Sales_Info = "Error occured while fetching retail sales information";
    public static Error_occured_while_fetching_stores = "Error occured while fetching stores";
    public static Calculate_Order_Total_CC_Initiated_Successfully = "Calculate Order Total CC initiated Successfully";
    public static Calculate_Order_Total_CC_Error = "Something went wrong. While calculating Total order CC";
    public static Revise_Intitiated_Successfully = "Revise action initiated Successfully";
    public static Revise_Error = "Error occured while revising the shared retail order sales";
    public static Approve_Intitiated_Successfully = "Approve action initiated Successfully";
    public static Approve_Error = "Error Occured while approving the shared retail order sales";
    public static ARS_Delete_Error = "Something went wrong while deleting record";
    public static ARS_Update_Error = "Something went wrong while updating record";
    public static ARS_Create_Error = "Error While creating shared retail sales";
    public static Already_Exist = "Already Exist";
    public static Not_Exist = "Not Exist";
    public static UPDATE = "UPDATE";
    public static DELETE = "DELETE";
    public static Request_failed = "Request failed";
    public static FAILED = "FAILED";
    public static Error = "Error";
    public static Approve = "approve";
    public static Completed = "Completed";
    public static Revise = "Revise";
    public static Pending = "Pending";
    public static Progress = "Progress";
    public static Not_Available = "Not Available";
    public static Revision = "Revision";

    public static Check_icon_class = "fa fa-check-circle fa-2x check_icon_color";
    public static Check_icon_progress_class = "fa fa-check-circle fa-2x progress_color";
    public static Pending_icon_class = "fa fa-clock-o fa-2x pending_icon_color";
    public static Error_icon_class = "fa fa-exclamation-circle fa-2x alert-text";
    public static active_Spinner_Green = "active active_green";
    public static active_Spinner_Red = "active active_red";
    public static active_Spinner_orange = "active active_orange";

    public static Month_End_process_is_In_Progress = "Month End process is In Progress";
    public static Month_End_process_is_Completed = "Month End process is Completed";
    public static Order_Total_and_CC_Calculation_is_In_Progress = "Order Total and CC Calculation is In Progress";
    public static Order_Total_and_CC_Calculation_is_Failed = "Order Total and CC Calculation is Failed";
    public static Order_Total_and_CC_Calculation_is_Completed = "Order Total and CC Calculation is Completed";
    public static Revise_Action_is_In_Progress = "Revise Action is In Progress";
    public static Revise_Action_is_Completed = "Revise Action is Completed";
    public static Revise_Action_is_Failed = "Revise Action is Failed";
    public static WWRTL_Product_File_Upload_In_Progress = "WWRTL Product File Upload In Progress";
    public static WWRTL_Product_File_Upload_Completed = "WWRTL Product File Upload Completed";
    public static WWRTL_Product_File_Upload_Failed = "WWRTL Product File Upload Failed";
    public static Order_Creation_in_Progress = "Order Creation in Progress";
    public static Order_Creation_Completed = "Order Creation Completed";
    public static Order_Creation_Failed = "Order Creation Failed";
    public static Product_revision_set_with_WWRTL_Item_uploaded_to_Titan = "Product revision set with WWRTL Item uploaded to Titan";
    public static Qualified_subscribers_are_not_available_in_this_store = "Qualified subscribers are not available in this store for current month";
    public static Subscribers_are_not_available_in_this_store = "Subscribers are not available in this store for current month" 

    }


// WEBPACK FOOTER //
// ./src/app/customerservice/constants/anonymous-retail-orders.constants.ts